import React, { useState } from "react";

// Reflect the app's real reaction set (same glyphs as the feed/comment reactions).
export const REACTION_EMOJI = { love: "👍", adore: "❤️", amen: "🙏", gloire: "🙌", sad: "😢", rire: "😂", wow: "😮" };
const FALLBACK_EMOJIS = ["👍", "❤️", "🙏", "🙌", "😢", "😂", "😮"];

// Build the live reaction glyph list from the shared reactions config.
export const emojisFromConfig = (config) => {
  const list = (config?.reactions || [])
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((r) => REACTION_EMOJI[r.key])
    .filter(Boolean);
  return list.length ? list : FALLBACK_EMOJIS;
};

export const useFloatingReactions = () => {
  const [floats, setFloats] = useState([]);
  const push = (emoji) => {
    const mk = (opts) => ({
      id: Date.now() + Math.random(),
      left: 6 + Math.random() * 78,
      dur: 3 + Math.random() * 1.6,
      size: 26 + Math.round(Math.random() * 26),
      drift: Math.round((Math.random() * 2 - 1) * 70),
      rot: Math.round((Math.random() * 2 - 1) * 40),
      delay: Math.round(Math.random() * 220) / 1000,
      ...opts,
    });
    const items = [mk({ emoji })];
    // On-brand: a "🙏" also floats an animated "Amen" bubble.
    if (emoji === "🙏") items.push(mk({ amen: true, left: 22 + Math.random() * 50, dur: 3.4 }));
    setFloats((cur) => [...cur.slice(-34), ...items]);
    const ids = items.map((i) => i.id);
    setTimeout(() => setFloats((cur) => cur.filter((x) => !ids.includes(x.id))), 5200);
  };
  return [floats, push];
};

export const FloatingReactions = ({ floats }) => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden z-10" data-testid="live-reactions-overlay">
    {floats.map((f) => (
      <span
        key={f.id}
        className={`live-float absolute bottom-16 select-none${f.amen ? " live-amen" : ""}`}
        style={{
          left: `${f.left}%`,
          fontSize: f.amen ? undefined : `${f.size}px`,
          animationDuration: `${f.dur}s`,
          animationDelay: `${f.delay}s`,
          "--drift": `${f.drift}px`,
          "--rot": `${f.rot}deg`,
        }}
      >
        {f.amen ? <span className="live-amen-bubble">Amen 🙏</span> : f.emoji}
      </span>
    ))}
  </div>
);

export const ReactionButtons = ({ onSend, emojis = FALLBACK_EMOJIS }) => (
  <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2" data-testid="live-reaction-buttons">
    {emojis.map((e, i) => (
      <button
        key={e}
        type="button"
        onClick={() => onSend(e)}
        className="h-10 w-10 rounded-full grid place-items-center text-xl transition-transform hover:scale-125 active:scale-90"
        style={{ background: "rgba(0,0,0,0.45)", backdropFilter: "blur(6px)" }}
        data-testid={`live-react-btn-${i}`}
      >
        {e}
      </button>
    ))}
  </div>
);
